export const CHANGE_COMPONENT_HEIGHT = 'CHANGE_COMPONENT_HEIGHT';
export const LOGOUT = 'LOGOUT';
export const LOGIN = 'LOGIN';
export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export const ERROR_REFRESH_TOKEN = 'ERROR_REFRESH_TOKEN';
export const CHANGE_EQUIPMENT_FILTER = 'CHANGE_EQUIPMENT_FILTER';
export const ADD_NEW_MESSAGE = 'ADD_NEW_MESSAGE';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';
export const UPDATE_USER_POSITION = 'UPDATE_USER_POSITION';